module.exports = __webpack_public_path__ + "static/media/BS_O_Timeless_Sforza_DKGold.dec71c8b.png";